import styled from "styled-components";

export const StyledFooter = styled.footer`

    background-color: #222;
    color: #fff;
`;

export const FooterMobile = styled.section`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    font-size: 14px;
    height: 70px;
    height: 90px !important;
    border-top: solid 1px #999999 !important;

    a {
        color: #91c508 !important;
    }

    a:visited {
        color: #91c508 !important;
    }

    @media (min-width: 768px){
        .col-info {
        margin-top: 30px;
        width: 50%;
        white-space: nowrap;

        .policy{
            a {
                color: #91c508 !important;
                margin-left: 8px !important;
            }

            a:hover{
                color: #91c508 !important;
            }

            a:visited{
                color: #91c508 !important;
            }
        }
    }

    .col-rif{

        @media (min-width: 1026px){
            margin-top: 30px;
        }
        width: 10%;
        span {
            margin-left: 8px;
            @media (max-width: 768px){
                font-size: 12px !important;
            }
        }
    }
    }

    @media (max-width: 1024px){

        height: 200px !important;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        padding-bottom: 50px;

        .col-info {
            margin-top: 40px !important;
            width: 100%;
            display: flex;
            flex-direction: column;

            .information {
                display:flex;
                flex-direction: column;
            }
        }

        .col-rif {
            width: 100%;
        }
    }
`;
